import { createReducer } from '@reduxjs/toolkit';
import { SUMMARY_DRAWER_OPEN } from '../actions/actionCreators';

const summaryDrawer = createReducer({ isOpen: false },
  (builder) => {
    builder
      .addCase(SUMMARY_DRAWER_OPEN, (state, action) => ({ ...state, isOpen: action.payload }));
  }
);
export default summaryDrawer;